"use strict";
exports.__esModule = true;
exports.SvgToolbarTextColor = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgToolbarTextColor = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", d: "M10.072 3c.24.002.47.12.611.323l.055.093 6.185 12.46.016.032a.75.75 0 01-.296.941l-.09.047-.095.041a.75.75 0 01-.918-.26l-.054-.093-1.044-2.101H5.563l-1.042 2.101a.75.75 0 01-.973.353l-.094-.04a.751.751 0 01-.386-.989l.015-.032L9.27 3.416a.75.75 0 01.735-.414l.068-.003zm-.069 2.541l-3.698 7.447H13.7l-3.697-7.447z" }),
        react_1["default"].createElement("path", { d: "M0 0h20v20H0z" })))); };
//# sourceMappingURL=ToolbarTextColor.js.map